// EON bulk order grid (blocks/eon-bulk-order.liquid): sums quantities per variant and adds
// every line to the cart in one request, then refreshes the cart drawer and header count.
// Loaded as a module: Shopify's asset minifier rewrites import() in classic scripts to require().
import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
  'use strict';

  function formatMoney(cents, format) {
    var parts = (cents / 100).toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, kind) {
      if (kind === 'amount_no_decimals') return whole;
      if (kind.indexOf('comma_separator') !== -1) return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (kind.indexOf('no_decimals') !== -1 ? '' : ',' + parts[1]);
      return whole + '.' + parts[1];
    });
  }

  function setup(root) {
    if (root.__eonBulk) return;
    root.__eonBulk = true;
    var data = JSON.parse(root.querySelector('[data-eon-bulk-data]').textContent);
    var inputs = root.querySelectorAll('input[data-variant]');
    var btn = root.querySelector('[data-add]');
    var msg = root.querySelector('[data-msg]');

    function lines() {
      var out = [];
      inputs.forEach(function (i) {
        var qty = Math.max(0, parseInt(i.value, 10) || 0);
        if (qty) out.push({ id: Number(i.dataset.variant), quantity: qty, price: Number(i.dataset.price) });
      });
      return out;
    }

    function update() {
      var count = 0, total = 0;
      lines().forEach(function (l) { count += l.quantity; total += l.quantity * l.price; });
      root.querySelector('[data-count]').textContent = count;
      root.querySelector('[data-total]').textContent = formatMoney(total, data.moneyFormat);
      btn.disabled = count === 0;
      btn.textContent = count ? 'Add ' + count + ' to cart' : 'Add to cart';
    }

    function say(text, isError) {
      msg.hidden = !text;
      msg.classList.toggle('is-error', !!isError);
      msg.innerHTML = '';
      if (!text) return;
      msg.appendChild(document.createTextNode(text));
      if (!isError) {
        var a = document.createElement('a');
        a.href = data.cartUrl;
        a.textContent = 'View cart →';
        msg.appendChild(document.createTextNode(' '));
        msg.appendChild(a);
      }
    }

    inputs.forEach(function (i) {
      i.addEventListener('input', update);
      i.addEventListener('focus', function () { i.select(); });
    });

    // The theme's variant picker is hidden on blank products, so switch the main gallery
    // ourselves. If the gallery has a slide for the chosen image, go to it; when it only
    // shows the selected variant's media, swap that image (and its zoom copy) instead.
    var section = root.closest('.shopify-section') || document;
    var activeRow = null;
    var shownFile = null;
    function fileOf(img) {
      var src = img && (img.getAttribute('src') || '');
      return src.split('?')[0].split('/').pop();
    }
    function showRow(row) {
      if (!row || row === activeRow || !row.dataset.image) return;
      var gallery = section.querySelector('media-gallery');
      if (!gallery) return;
      var file = row.dataset.image;
      var slideshow = gallery.querySelector('slideshow-component');
      var slides = slideshow ? Array.prototype.slice.call(slideshow.querySelectorAll('slideshow-slide')) : [];
      var index = -1;
      slides.forEach(function (slide, i) { if (index === -1 && fileOf(slide.querySelector('img')) === file) index = i; });

      if (index !== -1 && slides.length > 1 && typeof slideshow.select === 'function') {
        slideshow.select(index);
      } else {
        var first = slides[0] ? slides[0].querySelector('img') : gallery.querySelector('img');
        if (!first) return;
        var current = shownFile || fileOf(first);
        gallery.querySelectorAll('img').forEach(function (img) {
          if (fileOf(img) !== current) return;
          img.removeAttribute('srcset');
          img.src = row.dataset.imageSrc;
          if (row.dataset.imageSrcset) img.srcset = row.dataset.imageSrcset;
        });
        shownFile = file;
      }
      if (activeRow) activeRow.classList.remove('is-active');
      activeRow = row;
      row.classList.add('is-active');
    }
    root.addEventListener('click', function (e) {
      var row = e.target.closest && e.target.closest('[data-image]');
      if (row && root.contains(row)) showRow(row);
    });
    root.addEventListener('focusin', function (e) {
      var row = e.target.closest && e.target.closest('[data-image]');
      if (row && root.contains(row)) showRow(row);
    });

    btn.addEventListener('click', function () {
      var items = lines().map(function (l) { return { id: l.id, quantity: l.quantity }; });
      if (!items.length) return;
      var count = items.reduce(function (n, l) { return n + l.quantity; }, 0);
      btn.disabled = true;
      btn.textContent = 'Adding…';
      say('');
      // Ask for the cart drawer's HTML in the same request and announce the add with the theme's
      // cart event, so the drawer and header count update the way the theme's own add button does.
      var sections = [];
      document.querySelectorAll('cart-items-component').forEach(function (c) {
        if (c.dataset.sectionId) sections.push(c.dataset.sectionId);
      });
      var deferred = CartLinesUpdateEvent.createPromise();
      root.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: items.map(function (l) { return { merchandiseId: String(l.id), quantity: l.quantity }; }),
        promise: deferred.promise
      }));
      fetch(data.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sections.join(',') })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
          return fetch(data.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (c) { return c.json(); }).then(function (cart) {
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, source: 'eon-bulk-order', itemCount: count, sections: j.sections, didError: false }
            });
          });
        });
      }).catch(function (err) {
        deferred.reject(err);
        throw err;
      }).then(function () {
        inputs.forEach(function (i) { i.value = '0'; });
        update();
        say(count + (count === 1 ? ' item' : ' items') + ' added to your cart.');
      }).catch(function (err) {
        say((err && err.message) || 'Something went wrong. Please try again.', true);
        update();
      });
    });

    update();
  }

  function init() { document.querySelectorAll('[data-eon-bulk]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:block:select', init);
  document.addEventListener('shopify:section:load', init);
})();
